import type { Account } from "@onestore/api/account"
import type { Basket } from "@onestore/api/basket"
import { removeCloseConfirmation } from "@onestore/onestore-store-common/functions"
import type { AxiosError } from "axios"
import storeApi from "~/lib/api"
import Storage from "~/lib/storage"
import type { AppDispatch } from "../reducer"

export enum AccountActionTypes {
  ACTION_ACCOUNT_UPDATE = "@account/UPDATE",
  ACTION_ACCOUNT_LOGOUT = "@account/LOGOUT",
}

export interface AccountUpdateAction {
  type: AccountActionTypes.ACTION_ACCOUNT_UPDATE
  account: Account | null
}

export interface AccountLogoutAction {
  type: AccountActionTypes.ACTION_ACCOUNT_LOGOUT
}

export type AccountAction = AccountUpdateAction | AccountLogoutAction

export function createAccountUpdateAction(
  account: Account | null
): AccountUpdateAction {
  return {
    type: AccountActionTypes.ACTION_ACCOUNT_UPDATE,
    account,
  }
}

export function createAccountLogoutAction(): AccountLogoutAction {
  return {
    type: AccountActionTypes.ACTION_ACCOUNT_LOGOUT,
  }
}

export interface AccountActions {
  clearAccount: {
    (): AccountAction
  }
  logoutAccount: {
    (token: string): AccountAction
  }
  logoutRedirectAccount: {
    (token: Basket.Token, redirect: string): AccountAction
  }
  saveSession: {
    (sessionId: string, expires: Date): AccountAction
  }
  updateAccount: {
    (account: Account | null): AccountAction
  }
}

export const clearAccount = () => (dispatch: AppDispatch) => {
  Storage.clearSessionId()
  dispatch(createAccountLogoutAction())
}

export const logoutAccount =
  (token: Basket.Token, onLogout?: CallableFunction) =>
  async (dispatch: AppDispatch) => {
    await storeApi.deleteSession(token).catch((error: AxiosError) => {
      console.warn("Wystapił błąd podcza wylogowywania użytkownika", error)
    })

    Storage.clearSessionId()
    dispatch(createAccountLogoutAction())

    if (onLogout) {
      onLogout()
    }
  }

export const logoutRedirectAccount =
  (token: Basket.Token, redirect: string) => async (dispatch: AppDispatch) => {
    await storeApi.deleteSession(token).catch((error: AxiosError) => {
      console.warn("Wystapił błąd podcza wylogowywania użytkownika", error)
    })

    Storage.clearSessionId()
    dispatch(createAccountLogoutAction())

    removeCloseConfirmation()
    document.location.href = redirect
  }

export const saveSession = (sessionId: string, expires: Date) => () => {
  Storage.setSession(sessionId, expires)
}

export const updateAccount =
  (account: Account | null) => (dispatch: AppDispatch) => {
    dispatch(createAccountUpdateAction(account))
  }
